import { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Segment } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';

import Logo from '@plone/volto/components/theme/Logo/Logo';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import Navigation from '@plone/volto/components/theme/Navigation/Navigation';

import SearchStrip from '../SearchStrip/SearchStrip';
import SearchWidget from '../SearchWidget/SearchWidget';

const messages = defineMessages({
  bookAppointment: {
    id: 'Book appointment',
    defaultMessage: 'DEMANAR HORA',
  },
});

const Header = ({ pathname }) => {
  const intl = useIntl();
  const [searchStripOpen, setSearchStripOpen] = useState(false);

  const toggleSearchStrip = () => {
    setSearchStripOpen((open) => !open);
  };

  const closeSearchStrip = () => {
    setSearchStripOpen(false);
  };

  return (
    <Segment basic className="header-wrapper" role="banner">
      <Container>
        <div className="header">
          <div className="logo-nav-wrapper">
            <div className="logo">
              <Logo />
            </div>
            <div className="nav-bundle">
              <Navigation pathname={pathname} />
              <div className="search">
                <SearchWidget
                  onToggle={toggleSearchStrip}
                  isOpen={searchStripOpen}
                />
              </div>
              <a
                href="https://espaipacient.clinicasantjosep.cat/"
                target="_blank"
                rel="noopener noreferrer"
                className="book-appointment-link"
              >
                {intl.formatMessage(messages.bookAppointment)}
              </a>
              <div className="language-selector">
                <LanguageSelector />
              </div>
            </div>
          </div>
        </div>
      </Container>
      <SearchStrip isOpen={searchStripOpen} onClose={closeSearchStrip} />
    </Segment>
  );
};

Header.propTypes = {
  pathname: PropTypes.string.isRequired,
};

export default Header;
